import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {OrderStatesActions} from '../store';
import {OrderStatesSelectors} from '../store/selectors';

@Injectable()
export class OrderStatesLoadedGuard implements CanActivate {

  constructor(private store$: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {
    return this.loadOrderStates().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadOrderStates(): Observable<boolean> {
    return this.store$.pipe(
      select(OrderStatesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store$.dispatch(OrderStatesActions.ReadOrderStates());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
